import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  UIMatch,
  useMatches,
} from "react-router-dom";
import Button from "./tailwind/button";

interface FileItem {
  id: number;
  title: string;
  comment?: string | null;
}

export interface TitleProps {
  files: FileItem[];
  currentId?: string | number | null;
  onEdit: () => void;
  onChange?: (value: string) => void;
  title?: string;
  comment?: string | null;
}

export type CustomHandle = {
  title?: string;
  getTitle?: (
    params: Record<string, string | undefined>
  ) => string;
};

export default function Title({
  files,
  currentId,
  onChange,
  onEdit,
  title,
}: TitleProps) {
  const getFileTitle = (file: FileItem) => {
    return file.comment || file.title;
  };

  const matches = useMatches();

  const typedMatches =
    matches as UIMatch<unknown, CustomHandle>[];

  const currentMatch =
    typedMatches[typedMatches.length - 1];

  let pageTitle = currentMatch?.handle?.title || "";

  if (currentMatch?.handle?.getTitle) {
    pageTitle = currentMatch.handle.getTitle(
      currentMatch.params
    );
  }

  const selectedValue =
    currentId != null && currentId !== ""
      ? String(currentId)
      : "";

  return (
    <h1 className="text-dark-m3 pb-0 mb-1 text-130">
      <div
        className={files.length === 1 ? "" : "btn-group"}
      >
        <span className="d-lg-inline float-right">
          {pageTitle}
        </span>

        {files.length === 1 ? (
          <small> {getFileTitle(files[0])}</small>
        ) : (
          <div className="dropdown dd-backdrop dd-backdrop-none-md ml-3">
            <select
              id="tour-file-select"
              className="btn btn-sm btn-light-secondry"
              value={selectedValue}
              onChange={(event) => {
                onChange?.(event.target.value);
              }}
            >
              <option value="" disabled hidden>
                انتخاب کنید...
              </option>

              {files.map((file) => (
                <option
                  key={file.id}
                  value={String(file.id)}
                >
                  {getFileTitle(file)}
                </option>
              ))}
            </select>
          </div>
        )}

        {title && (
          <Button
            className="btn-light-secondry"
            onClick={onEdit}
          >
            <FontAwesomeIcon icon="pen" />
          </Button>
        )}
      </div>
    </h1>
  );
}
